import { useDispatch } from "react-redux";

import type {
    SelectionDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import {
    ManualSelectionItem
} from "app/pages/sales-intelligence/common-components/table-actions-panel";
import {
    setSelectedRowsAction,
    tableRowsSelectionToggledAction,
} from "app/pages/sales-intelligence/modules/company-analysis/store/competitors/action-creators";

export const useTableSelections = () => {
    const dispatch = useDispatch();

    const clearAndCloseRowsSelection = () => {
        dispatch(setSelectedRowsAction([]));
        dispatch(tableRowsSelectionToggledAction(false));
    };

    const onSelectionChange = (item: Readonly<SelectionDropdownItem>) => {
        if (item.id === ManualSelectionItem.ID) {
            dispatch(tableRowsSelectionToggledAction(true));
        } else {
            clearAndCloseRowsSelection();
        }
    };

    return { clearAndCloseRowsSelection, onSelectionChange };
};
